import { Link } from "react-router-dom";

interface NavbarItemProps {
  name: string;
  path: string;
  isSelected: boolean;
  isExternal?: boolean;
}

function NavbarItem({ name, path, isSelected, isExternal }: NavbarItemProps) {
  if (isExternal) {
    return (
      <a
        href={path}
        target="_blank"
        rel="noopener noreferrer"
        className={isSelected ? "active" : ""}
      >
        {name}
      </a>
    );
  }

  return (
    <Link to={path} className={isSelected ? "active" : ""}>
      {name}
    </Link>
  );
}

export default NavbarItem;
